


































































































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import {ELevel} from '@/services/Menus'
import {IPaymentHistory} from '@/store/modules/views/paymentHistory/states'
import { IBank } from '@/store/modules/components/states'
import moment from 'moment'
import { ICenter } from '@/store/modules/views/center/states'
@Component
export default class PaymentHistoryDialog extends VueExtendedBaseComponent {

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  @Action('paymentHistory/putPaymentHistory')
  private putPaymentHistory!: (options: {}) => void

  @Getter('components/banks')
  private banks: IBank[]

  @Getter('center/centerById')
  private centerById!: {[centerId: string]: ICenter}

  get timeMax() {
    const now = moment()
    now.locale('th')
    if (now.format('YYYY-MM-DD') === this.date) {
      const time = now.format('HH:mm')
      if (this.time > time) {
        this.time = null
      }
      return time
    }
    return null
  }

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private paymentHistory!: IPaymentHistory & {roles: string[], permissions: string[], accounts: string[]}

  private loading = false
  private date = null
  private time = null
  private menu = false
  private menu2 = false
  private valid = false
  private isReadOnly = false
  private bank: {name: string, text: string} = null
  private accountNumber = ''
  private name = ''
  private center = ''
  private amount = 0
  private slipImg = ''
  private isEnabled = false
  private isHidden = true
  private onInputImage(file) {
    this.slipImg = file.file
  }

  private async created() {
    this.slipImg = this.paymentHistory.slipImg || ''
    this.bank = _.find(this.banks, {name: this.paymentHistory.bank}) || null
    this.accountNumber = this.paymentHistory.accountNumber || ''
    const centerObj = this.centerById[this.paymentHistory.centerId]
    this.center = centerObj && centerObj.name || ''
    this.name = this.paymentHistory.name || ''
    this.amount = this.paymentHistory.amount || 0
    if (this.paymentHistory.status === 'อนุมัติ') {
      this.isEnabled = true
    }
  }

  get paymentHistoryDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        rejectButton: {
          title: 'ปฏิเสธ',
          action: this.rejectPaymentHistoryAction,
          disable: this.isEnabled,
          loading: this.loading,
          outlined: true,
          height: '30',
        },
        approveButton: {
          title: 'อนุมัติ',
          action: this.approvePaymentHistoryAction,
          loading: this.loading,
          disable: this.isEnabled,
          height: '30',
        },
      },
    }
  }

  private requireInput(value) { return value !== '' || 'จำเป็นต้องกรอก' }

  private changeDateType() {
    // console.log(this.timeMax)
    this.menu = false
  }

  private async approvePaymentHistoryAction() {
    this.loading = true
    try {
      if (!(this.date && this.time)) {
        this.updateSnackbar({txt: 'กรุณาเลือกวันเวลาเงินเข้า.', type: 'error'})
        this.loading = false
        return false
      }
      await this.putPaymentHistory({
        id: this.paymentHistory._id,
        jobId: this.paymentHistory.jobId,
        date: this.date,
        time: this.time,
        status: 'อนุมัติ',
      })
      this.updateSnackbar({txt: 'อนุมัติสำเร็จ.', type: 'success'})
      await this.callback()
      this.loading = false
      this.closeDialog()
    } catch (e) {
      await this.callback()
      this.loading = false
    }
  }
  private async rejectPaymentHistoryAction() {
    this.loading = true
    try {
      await this.putPaymentHistory({
        id: this.paymentHistory._id,
        jobId: this.paymentHistory.jobId,
        status: 'ปฏิเสธ',
      })
      this.updateSnackbar({txt: 'ปฏิเสธสำเร็จ.', type: 'success'})
      await this.callback()
      this.loading = false
      this.closeDialog()
    } catch (e) {
      await this.callback()
      this.loading = false
    }
  }

  private requireSelect(value) { return [(v) => !!v || 'จำเป็นต้องเลือก'] }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
